import LocationModal from "@/components/LocationModal";
import { createContext, useContext, useState } from "react";

interface LocationModalContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const LocationModalContext = createContext<
  LocationModalContextType | undefined
>(undefined);

export const LocationModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return (
    <LocationModalContext.Provider value={{ isOpen, open, close }}>
      {children}
      <LocationModal
        open={isOpen}
        onClose={() => {
          close();
        }}
      />
    </LocationModalContext.Provider>
  );
};

export const useLocationModal = () => {
  const context = useContext(LocationModalContext);
  if (context === undefined) {
    throw new Error(
      "useLocationModal must be used within a LocationModalProvider"
    );
  }
  return context;
};
